<script setup>
    import { defineProps, defineEmits, watch } from 'vue';
    //import { defineModel } from 'vue';
    import { ref } from 'vue';

    // ----------------------------
    // Props
    // ----------------------------
    const props = defineProps({
        counselores: {
            type: Object,
            required: true,
        },
        counselorPk: {
            type: String,
            default: '',
        },
        time: {
            type: String,
            default: '',
        }

    });

    // ----------------------------
    // リアクティブ変数
    // ----------------------------
    const selectRadio = ref('');
    // ----------------------------
    // emit
    // ----------------------------
    const emit = defineEmits(['childEmit', 'counselorProfileTarget']);
    // ----------------------------
    // watch
    // ----------------------------
    watch(
        () => props.counselorPk,
        (newDate) => {
            selectRadio.value = props.time + newDate
        },
        { immediate: true }
    );

    // ----------------------------
    // 関数
    // ----------------------------
    function emitEvent(CounselorPk, Time) {
        emit('childEmit', CounselorPk, Time);
    }
    function clickedCounselorProfileTarget(CounselorPk) {
        emit('counselorProfileTarget', CounselorPk);
    }

    const jumpId = ref('block1');

    function jumpTable(id) {
        const table = document.getElementById('counselorScheduleTable');
        const target = document.getElementById(id);
        if (target) {
            const offsetTop = target.offsetTop
            table.scrollTo({
                top: offsetTop,
                behavior: 'smooth'
            })
        }
        jumpId.value = id;
    }

</script>

<template>
    <ul id="counselorScheduleBtnArea">
        <li :class="{ selected: jumpId === 'block1' }">
            <button type="button" @click="jumpTable('block1')">{{ $t('reservePlanningCounselor.parts.button3') }}</button>
        </li>
        <li :class="{ selected: jumpId === 'block2' }">
            <button type="button" @click="jumpTable('block2')">{{ $t('reservePlanningCounselor.parts.button4') }}</button>
        </li>
        <li :class="{ selected: jumpId === 'block3' }">
            <button type="button" @click="jumpTable('block3')">{{ $t('reservePlanningCounselor.parts.button5') }}</button>
        </li>
    </ul>
    <table id="counselorScheduleTable">
        <tbody>
            <tr class="unvisible" id="block1" />
            <template v-for="(counselorValue, index) in props.counselores" :key="'counselor_time_' + index">
                <template v-if="counselorValue[0].Time === '12:00'">
                    <tr class="unvisible" id="block2"></tr>
                </template>
                <template v-if="counselorValue[0].Time === '17:00'">
                    <tr class="unvisible" id="block3"></tr>
                </template>
                <tr>
                    <th>
                        <span>{{ counselorValue[0].Time }}</span>
                    </th>
                    <td>
                        <ul>
                            <li v-for="(counselor, index2) in counselorValue" :key="'counselor_' + index + '_' + index2">
                                <input type="radio" :id="'label-' + index + '_' + index2" name="counselorGroup" :value="`${counselor.Time}${counselor.CounselorPk}`" v-model="selectRadio" />
                                <label :class="{ 'name selected': selectRadio === `${counselor.Time}${counselor.CounselorPk}`, name: selectRadio !== `${counselor.Time}${counselor.CounselorPk}` }" :for="'label-' + index + '_' + index2" @click="emitEvent(counselor.CounselorPk, counselor.Time)">{{ counselor.CounselorNm }}</label>
                                <button type="button" class="profile" @click="clickedCounselorProfileTarget(counselor.CounselorPk)">{{ $t('reservePlanningCounselor.parts.button6') }}</button>
                            </li>
                        </ul>
                    </td>
                </tr>
            </template>
        </tbody>
    </table>
</template>

<style></style>
